import { render, staticRenderFns } from "./listaProtocolos.vue?vue&type=template&id=7244d306"
import script from "./listaProtocolos.vue?vue&type=script&lang=js"
export * from "./listaProtocolos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports